<script setup>
  import { useAttrs, computed } from 'vue'

  const { menuMain } = useMainMenu()
  const attrs = useAttrs()
  const route = useRoute()
  const dropdown = attrs['data-dropdown']
  const title = computed(() => {
    return menuMain?.value?.[dropdown]?.title
  })

  const directPath = computed(() => {
    return menuMain?.value?.[dropdown]?.path
  })

  /** TODO : Manage translation */
  const isInSection = () => {
    const sectionUrls = menuMain?.value?.[dropdown]?.items?.map((item) => {
      if (item.params) {
        return { path: item.path, params: item.params }
      } else {
        return { path: item.path }
      }
    })

    if (!sectionUrls || typeof route.name !== 'string') return false

    const hasUrls = sectionUrls.some((url) => {
      const startWith = route.name.startsWith(url.path)
      if (url.params) {
        const hasParams = Object.entries(url.params).every(([key, value]) => route.params[key] === value)
        return startWith && hasParams
      } else {
        return startWith && url.path !== 'index'
      }
    })

    return hasUrls
  }
</script>

<template>
  <NuxtLink
    v-if="directPath"
    :to="directPath"
    class="!h-[49px] !pb-[40px] block"
    :class="{ 'uia-link-active': isInSection() }"
    tabindex="-1"
  >
    {{ title }}
  </NuxtLink>
  <button v-else class="!h-[49px] !pb-[40px]" :class="{ 'uia-link-active': isInSection() }" tabindex="-1">
    {{ title }}
  </button>
</template>
